exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-pag[data-v-d9958e7a] {\n  cursor: pointer;\n  background: transparent;\n}\n.icon[data-v-d9958e7a] {\n  height: 20px;\n  width: auto;\n}", ""]);

// exports
